module.exports = __webpack_public_path__ + "img/ritinha2.e19846a9.png";